import React, { Component } from 'react';

import '../css/widget/widget.slide.up.overlay.css'

class WidgetSlideUpOverlay extends Component {
    constructor(props) 
    {
        super(props);

        this.state = {
            isHovered: false,
            shouldShowOverlay: false,
            isAnimating: false
        };

        this.hoverTimer = null;
        this.leaveTimer = null;
        this.lastHoverTime = 0;
    }

    handleMouseEnter = () => {

        if (Date.now() - this.lastHoverTime < 100) return;

        // 清除可能存在的离开计时器
        clearTimeout(this.leaveTimer);
        
        // 设置悬停状态
        this.setState({ isHovered: true });
        
        // 延时显示蒙层
        this.hoverTimer = setTimeout(() => {
            this.setState({ shouldShowOverlay: true, isAnimating: true });
        }, this.props.delay || 300); // 默认300毫秒延迟
    };

    handleMouseLeave = () => {
        
        this.lastHoverTime = Date.now();

        // 清除可能存在的悬停计时器
        clearTimeout(this.hoverTimer);
        
        // 设置离开状态
        this.setState({ isHovered: false });
        
        // 延时隐藏蒙层
        this.leaveTimer = setTimeout(() => {
        this.setState({ shouldShowOverlay: false });
        
        // 动画结束后重置状态
        setTimeout(() => {
                this.setState({ isAnimating: false });
            }, 500); // 等待动画完成
        }, 200); // 离开时稍短延迟
    };

    componentWillUnmount() {
        
        // 组件卸载时清除所有计时器
        clearTimeout(this.hoverTimer);

        clearTimeout(this.leaveTimer);
    }

  render() {
        const { isHovered, shouldShowOverlay, isAnimating } = this.state;
        const { 
            children,
            overlayContent,
            overlayHeight = '100%',
            animationDuration = 500,
            data

        } = this.props;

        return (
            <div 
                className={ isHovered ? "sf-slide-up-overrlay sg-slide-up-overrlay active" : "sf-slide-up-overrlay sg-slide-up-overrlay"}
                style={{ height: 'fit-content' }}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                {/* 主内容 */}
                {children}
                
                {/* 蒙层 */}
                <div
                    className= "sf-slide-up-overrlay-mask sg-slide-up-overrlay-mask"
                    style={{ 
                        height: overlayHeight,
                        transitionDuration: `${animationDuration}ms`
                    }}
                >
                    {overlayContent || (
                        <div className="h-full flex flex-col justify-center">
                            <h3 className="text-lg font-bold">{data.title}</h3>
                            <p className="mt-2 text-sm">{data.description}</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default WidgetSlideUpOverlay;